import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import apiService from "../api/service";
import qs from 'query-string';

const NAME = 'search'

// Thunks
export const setCollection = createAsyncThunk(`${NAME}/setCollection`, async (options) => {
  return options
})

export const getQueryResults = createAsyncThunk(`${NAME}/getQueryResults`, async (options) => {
  const { apiKey, needHelper } = options
  let helper
  const data = await apiService.get(apiKey, options);

  if(needHelper){
    helper = await apiService.get('search', {...options, limit: 1, offset: '0'});
  }

  return {data, helper};
})

const searchSlice = createSlice({
  name: NAME,
  initialState: {
    collection: 'organizations',
    selectedApproaches: [],
    selectedIssues: [],
    selectedOrganizationTypes: [],
    selectedProvince: '',
    selectedCity: '',
    queryString: '',
    queryResults: [],
    queryObject: {},
    totalResults: 0,
    countData: {
      programs: 0,
      organizations: 0,
      events: 0,
      resources: 0,
      blogs: 0
    }
  },
  reducers: {
    setQueryString(state, action) {
      const { payload } = action
      state.queryString = payload
      state.queryObject = {...qs.parse(payload)}
    },
    setSelectedApproaches(state, action) {
      state.selectedApproaches = action.payload
    },
    setSelectedIssues(state, action) {
      state.selectedIssues = action.payload
    },
    setSelectedOrganizationTypes(state, action) {
      state.selectedOrganizationTypes = action.payload
    },
    setSelectedProvince(state, action) {
      state.selectedProvince = action.payload
    },
    setSelectedCity(state, action) {
      state.selectedCity = action.payload
    },
    emptyAllSelectedCollections(state, action) {
      state.selectedApproaches = []
      state.selectedIssues = []
      state.selectedOrganizationTypes = []
      state.selectedProvince = []
      state.selectedCity = ''
    },
  },
  extraReducers: {
    [setCollection.fulfilled]: (state, action) => {
      state.collection = action.payload
    },
    [getQueryResults.fulfilled]: (state, action) => {
      const { payload = {} } = action
      const { data, helper } = payload

      state.queryResults = {...data}

      if(helper && helper.countResults){
        const countData = helper.countResults
        state.countData = {
          programs: countData?.program || 0,
          organizations: countData?.organisasi || 0,
          events: countData?.event || 0,
          resources: countData?.resource || 0,
          blogs: countData?.blog || 0
        }
      }

      if(data.count === 0){
        state.totalResults = data.count
      } else {
        if(data.count){
          state.totalResults = data.count
        }
      }
    }
  }
});

export const {
  setQueryString,
  setSelectedApproaches,
  setSelectedIssues,
  setSelectedOrganizationTypes,
  setSelectedProvince,
  setSelectedCity,
  emptyAllSelectedCollections
} = searchSlice.actions;

export default searchSlice.reducer
